export default __webpack_public_path__ + "img/c68a4cce5998ed1939564820d8ba66d9.svg";